import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import db from "astrid-firebase/src/db";
import organizationTypes from "astrid-firestore/src/api/organizations/constants/organizationTypes";
import useDocumentData from "astrid-firestore/src/hooks/useDocumentData";

import { localStorage } from "../../../helpers/fnc";

import { useProfile } from "../../authentication/state/profile";

import { useOrganizationId } from "../state/organizationId";
import { useOrganizationType } from "../state/organizationType";
import getLocationOrganization from "../utils/getLocationOrganization";
import isUserOrganization from "../utils/isUserOrganization";

import useSelectOrganization from "./useSelectOrganization";
import useUserOrganizations from "./useUserOrganizations";

export default function useCurrentOrganization() {
	const user = useProfile();
	const location = useLocation();
	const selectOrganization = useSelectOrganization();
	const organizations = useUserOrganizations(user);

	const localOrganization = localStorage("organizations", user?.id);

	const remembered = {
		id: useOrganizationId() || localOrganization?.id,
		type: useOrganizationType() || localOrganization?.type,
	};

	const { id, type } = getLocationOrganization(
		location,
		isUserOrganization(user, organizations, remembered.id) ? remembered : {},
	);

	useEffect(() => {
		if (id && type) {
			selectOrganization({ id, type });
		}
	}, [id, selectOrganization, type]);

	const [document, loading, error] = useDocumentData(
		id && type !== organizationTypes.NARRATOR && db.collection("organizations").doc(id),
	);

	const organization = document?.id === id ? document : undefined;

	return [organization || { id, type }, loading, error];
}
